import React from "react";
import { Link } from "react-router-dom";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="card-bordered p-12 text-center" data-testid="error-boundary">
          <div className="font-display text-xl font-bold mb-2">Something went wrong</div>
          <p className="text-sm text-[var(--text-2)] mb-5">We hit a snag rendering this page. Please try again.</p>
          <Link to="/" className="btn-primary text-sm inline-block">Back to Dynasty Metrics</Link>
        </div>
      );
    }
    return this.props.children;
  }
}
